






































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  minLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";

import SubmitResetButtonGroop from "@/components/app/shared/btn&dd/submit-reset-button-groop.vue";
import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { ComplexMenuItem } from "@/@types/menu/complex-menu";
import type { Locale, LanguageCode } from "@/@types/_shared/locale";

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    LanguagesBtns,
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(100),
    },
    calorie: {
      numeric,
      minValue: minValue(0),
    },
    proteins: {
      numeric,
      minValue: minValue(0),
    },
    fats: {
      numeric,
      minValue: minValue(0),
    },
    carbohydrates: {
      numeric,
      minValue: minValue(0),
    },
  },
})
class AddComplexMenuVariantDishModal extends Vue {
  @Prop({ type: Object, default: null }) item!: ComplexMenuItem | null;
  @Prop({ type: String, default: "" }) shopId!: string;

  currentLocale: LanguageCode = this.$store.getters.getLanguages
    ? this.$store.getters.getLanguages[0]
    : "ru";

  // Form fields
  name = "";
  names: Locale = {};

  calorie: number | null = null;
  proteins: number | null = null;
  fats: number | null = null;
  carbohydrates: number | null = null;

  // Computed getter for the dish data
  get dish(): ComplexMenuItem {
    return {
      _id: this.item?._id || "",
      name: this.names as Record<string, string>,
      calorie: this.calorie || 0,
      proteins: this.proteins || 0,
      fats: this.fats || 0,
      carbohydrates: this.carbohydrates || 0,
    };
  }

  onSubmit(e: Event) {
    e.preventDefault();
    this.$v.$touch();
    if (this.$v.$invalid) return;

    this.$emit("setDish", this.dish);
    this.$bvModal.hide("add-complex-menu-variant-dish");
  }

  @Watch("name")
  addName() {
    this.$set(this.names, this.currentLocale, this.name);
  }

  @Watch("currentLocale")
  changeLocale() {
    this.name = this.names[this.currentLocale] || "";
  }

  @Watch("item")
  createFields() {
    if (!this.item) return;
    this.names = this.item.name || {};
    this.calorie = this.item.calorie || null;
    this.proteins = this.item.proteins || null;
    this.fats = this.item.fats || null;
    this.carbohydrates = this.item.carbohydrates || null;

    this.changeLocale();
  }

  isClean() {
    this.name = "";
    this.names = {};
    this.calorie = null;
    this.proteins = null;
    this.fats = null;
    this.carbohydrates = null;
    this.$v.$reset();
  }
}

export default AddComplexMenuVariantDishModal;
